/* eslint-disable import/extensions */
/* eslint-disable @typescript-eslint/no-explicit-any */

import { REQUIRED_FIELD_ERROR } from '@masfront/common-b2c'
import { string, object } from 'yup'

const contractDestinationSchema = object().shape({
  contractDestination: string().label('destino de la factura').required(REQUIRED_FIELD_ERROR),
})

export default contractDestinationSchema
